const theme = {
  colors: {
    primary: '#1B2B4D',      // Navy
    secondary: '#E8E8E8',    // Light Gray
    black: '#1A1A1A',        // Black
    white: '#FAFAFA',        // Off White
    grayLight: '#F5F5F5',    // Variação mais clara do Light Gray
    grayMedium: '#949494',   // Variação média do Light Gray
    grayLighter: '#cececeff',   // Variação mais clara do Medium Gray
  },
  fonts: {
    heading: 'Montserrat, sans-serif',    // Títulos
    subheading: 'Poppins, sans-serif',    // Subtítulos/Destaques
    body: 'Roboto, sans-serif',           // Corpo de texto
  },
  fontSizes: {
    display: '3.5rem',
    h1: '3rem',
    h2: '2.25rem',
    h3: '1.5rem',
    bodyLg: '1.125rem',
    body: '1.1rem',
    small: '0.875rem',
  },
  lineHeights: {
    tight: 1.2,
    normal: 1.6,
    relaxed: 1.8,
  },
  fontWeights: {
    regular: 400,
    medium: 500,
    semiBold: 600,
    bold: 700,
  },
  borderRadius: {
    small: '4px',
    medium: '8px',
    large: '12px',
  },
  breakpoints: {
    sm: '576px',
    md: '768px',
    lg: '992px',
    xl: '1200px'
  },
  spacing: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2rem',
    xxl: '3rem',
  },
  boxShadow: '0 4px 10px rgba(0, 0, 0, 0.08)',
  boxShadowHover: '0 10px 24px rgba(0, 0, 0, 0.12)'
};

export default theme;
